import {
  GROWZ_GET_ALL_CAMPAIGNS_NEW,
  GROWZ_GET_GOAL_BY_ID,
  GROWZ_GET_GOAL_BY_SLUG,
  GROWZ_POST_GOAL_LAUNCH,
  GROWZ_PUT_GOAL_UNLAUNCH,
  GROWZ_PUT_GOAL_RESUME,
  GROWZ_GET_ALL_ADGROUPS,
  GET_ALL_PRODUCTS,
  GROWZ_CREATIVE_LIST,
  STRATEGY_INPUTS_BY_SLUG,
} from '../../../config/api';
import http from '../../../config/http';
import { devLog } from '../../../utils';

export const MICRO_GOALS_SET_GOAL_DATA = 'MICRO_GOALS_FETCH_GOAL';
export const MICRO_GOALS_LAUNCH_SET_STEP = 'MICRO_GOALS_LAUNCH_SET_STEP';
export const MICRO_GOALS_LAUNCH = 'MICRO_GOALS_LAUNCH';
export const MICRO_GOALS_SET_INPUT_DATA = 'MICRO_GOALS_SET_INPUT_DATA';
export const MICRO_GOALS_RESET_CONFIG = 'MICRO_GOALS_RESET_CONFIG';

export const MICRO_GOALS_SET_CONFIG = 'MICRO_GOALS_SET_CONFIG';
export const MICRO_GOALS_REMOVE_CONFIG = 'MICRO_GOALS_REMOVE_CONFIG';
export const MICRO_GOALS_PUSH_CONFIG = 'MICRO_GOALS_PUSH_CONFIG';
export const MICRO_GOALS_POP_CONFIG = 'MICRO_GOALS_POP_CONFIG';
export const UPDATE_GOAL_CONFIGS = 'UPDATE_GOAL_CONFIGS';
export const MICRO_GOALS_REPLACE_CONFIG = 'MICRO_GOALS_REPLACE_CONFIG';

export const MICRO_GOALS_DELETE_CONFIG = 'MICRO_GOALS_DELETE_CONFIG';
export const MONITOR_ACTIVITY_SET_ACTIVE_STEP = 'MONITOR_ACTIVITY_SET_ACTIVE_STEP';
export const CREATIVE_SET_ACTIVE_STEP = 'CREATIVE_SET_ACTIVE_STEP';

export const microGoalsFetchByIdAction = (goalId) => async (dispatch) => {
  try {
    const goal = await http.get(GROWZ_GET_GOAL_BY_ID.replace('{goalId}', goalId));
    dispatch({
      type: MICRO_GOALS_SET_GOAL_DATA,
      payload: goal.data,
    });
  } catch (e) {
    dispatch({
      type: MICRO_GOALS_SET_GOAL_DATA,
      payload: false,
    });
  }
};

export const microGoalsFetchBySlugAction = (goalSlug, location) => async (dispatch) => {
  try {
    const goal = await http.get(GROWZ_GET_GOAL_BY_SLUG.replace('{goalSlug}', goalSlug));
    dispatch({
      type: MICRO_GOALS_SET_GOAL_DATA,
      payload: goal.data,
    });
    if (location.state) {
      if (location.search === '?adgroups') {
        dispatch(microGoalsReplaceConfigByName('adgroups', location.state));
      } else {
        dispatch(microGoalsReplaceConfigByName('campaigns', location.state));
      }
    }
  } catch (e) {
    dispatch({
      type: MICRO_GOALS_SET_GOAL_DATA,
      payload: false,
    });
  }
};
export const updateGoalInputConfigs = (config) => ({
  type: UPDATE_GOAL_CONFIGS,
  payload: config,
});

export const microGoalsSetActiveStep = (step) => ({
  type: MICRO_GOALS_LAUNCH_SET_STEP,
  payload: step,
});

export const creativeSetActiveStep = (step) => ({
  type: CREATIVE_SET_ACTIVE_STEP,
  payload: step,
});

export const monitorActivitySetActiveStep = (step) => ({
  type: MONITOR_ACTIVITY_SET_ACTIVE_STEP,
  payload: step,
});

export const microGoalsGetCampaigns = () => async (dispatch) => {
  try {
    const campaigns = await http.get(GROWZ_GET_ALL_CAMPAIGNS_NEW, {
      params: { active: true, report: true },
    });
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'campaigns',
      payload: campaigns.data || [],
    });
  } catch (e) {
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      payload: [],
    });
  }
};

export const microGoalsGetAllInputs = (goalSlug) => async (dispatch) => {
  try {
    const response = await http.get(STRATEGY_INPUTS_BY_SLUG.replace('{strategySlug}', goalSlug));
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'campaigns',
      payload: response?.data?.campaigns || [],
    });
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'adgroups',
      payload: response?.data?.adGroups || [],
    });
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'creatives',
      payload: response?.data?.creatives || [],
    });
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'products',
      payload: response?.data?.products || [],
    });
  } catch (e) {
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      payload: [],
    });
  }
};

export const microGoalsGetAdgroups = () => async (dispatch) => {
  try {
    const adgroups = await http.get(GROWZ_GET_ALL_ADGROUPS, {
      params: { active: true, report: true },
    });
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'adgroups',
      payload: adgroups.data || [],
    });
  } catch (e) {
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      payload: [],
    });
  }
};

export const microGoalsGetCreatives = () => async (dispatch) => {
  try {
    const creatives = await http.get(GROWZ_CREATIVE_LIST);

    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'creatives',
      payload: creatives.data || [],
    });
  } catch (e) {
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'creatives',
      payload: [],
    });
  }
};

export const microGoalsGetProducts = () => async (dispatch) => {
  try {
    const products = await http.get(GET_ALL_PRODUCTS, {
      params: { active: true, report: true },
    });

    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      name: 'products',
      payload: products.data || [],
    });
  } catch (e) {
    devLog(e);
    dispatch({
      type: MICRO_GOALS_SET_INPUT_DATA,
      payload: [],
    });
  }
};

export const microGoalsPushConfigByName = (name, payload) => ({
  type: MICRO_GOALS_PUSH_CONFIG,
  name,
  payload,
});

export const microGoalsPopConfigByName = (name, payload) => ({
  type: MICRO_GOALS_POP_CONFIG,
  name,
  payload,
});

export const microGoalsDeleteConfigByName = (name, payload) => ({
  type: MICRO_GOALS_DELETE_CONFIG,
  name,
  payload,
});

export const microGoalsResetConfigByName = (name, defaultR = []) => ({
  type: MICRO_GOALS_RESET_CONFIG,
  name,
  payload: defaultR,
});

export const microGoalsReplaceConfigByName = (name, payload) => ({
  type: MICRO_GOALS_REPLACE_CONFIG,
  name,
  payload,
});

export const microGoalsLaunchAction = (payload, launchStep) => async (dispatch) => {
  try {
    await http.post(GROWZ_POST_GOAL_LAUNCH, payload);
    dispatch(microGoalsSetActiveStep(launchStep));
    dispatch(microGoalsPushConfigByName('launchStatus', true));
  } catch (e) {
    dispatch(microGoalsSetActiveStep(launchStep));
    dispatch(microGoalsPushConfigByName('launchStatus', false));
    if (e?.response?.data?.message) dispatch(microGoalsPushConfigByName('launchErrorMessage', e.response.data.message));
    else dispatch(microGoalsPushConfigByName('launchErrorMessage', e.message));
  }
};

export const microGoalsUnLaunchAction = (goalId) => async () => {
  try {
    await http.put(GROWZ_PUT_GOAL_UNLAUNCH.replace('{sellerMicroGoalId}', goalId));
  } catch (e) {
    alert('Unable to Unlaunch goal');
  }
};
export const microGoalsResumeAction = (goalId) => async () => {
  try {
    await http.put(GROWZ_PUT_GOAL_RESUME.replace('{sellerMicroGoalId}', goalId));
  } catch (e) {
    alert('Unable to Resume goal');
  }
};
